import { Shark, View, Utils } from "shark-mvc";
import moment from "moment";

import ClientFollowUp from "../../_shark_models/ClientFollowUp";

import templateContent from "./lead-details.html";
import followup_list_and_form from "../../_shark_templates/components/followup-list-and-form.html";

import { clientManager } from "../../_shark_jaws/managers/clientManager";
import { communicationManager } from "../../_shark_jaws/managers/communicationManager";
import { documentManager } from "../../_shark_jaws/managers/documentManager";
import followUpManager from "../../_shark_jaws/managers/followUpManager";
import followUpComponent from "../../components/followUp/followUpComponent";
import leadListView from "./leadListView";
import mainNavComponent from "../../_shark_jaws/components/mainNavComponent";
import { userManager } from "../../_shark_jaws/managers/userManager";

class LeadDetailsView extends View {
	constructor(name) {
		super(name);
		this.setTemplate(templateContent);
	}

	afterRender () {
		const currProspect = Shark.get("currProspect");
		
		if (!currProspect) {
			Shark.openPage(leadListView);
		}
		else {
			currProspect.parseReferenceLine();
		}

		const sectorSelect = document.querySelector(`[data-sh-prop="sector"]`);

		if (sectorSelect) {
			sectorSelect.querySelector(`[value="Geodrena"]`) ? sectorSelect.querySelector(`[value="Geodrena"]`).disabled = true : false;
			sectorSelect.querySelector(`[value="Green Paving"]`) ? sectorSelect.querySelector(`[value="Green Paving"]`).disabled = true : false;
		}
	}

	backToListBtn_clickHandler () {
		const { currProspect } = Shark.get();

		if (!currProspect.isDirty() || (currProspect.isDirty() && confirm("Sei sicuro di voler annullare le modifiche apportate?"))) {
			Shark.openPage(leadListView);
		}
	}

	beforeLoad () {
		window.scrollTo(0, 0);

		if (Shark.get("agentList").length === 0) {
			userManager.getList();
		}

		const currProspect = Shark.get("currProspect");
		if (currProspect) {
			this.set("currProspectIsPremium", currProspect.extraData.leadIsPremium);
			followUpComponent.set("targetItem", currProspect);
			this.getAttachments();
		}
	}

	beforeUnload () {
		Shark.set("currFollowUp", null);
	}

	deleteAttachmentBtn_clickHandler (event, data) {
		const { currProspect } = Shark.get();
		const attachment = Utils.safp(currProspect.__leadAttachmentList, "guid", data.guid);

		if (attachment && confirm(`Vuoi davvero cancellare l'allegato "${attachment.name}" da questo Lead?`)) {
			if (currProspect.deleteAttachment(attachment.guid)) {
				const newFollowUp = new ClientFollowUp({
					body: `È stato rimosso l'allegato "<span role="attachment-name">${attachment.name}</span>".`,
					clientGuid: currProspect.guid,
					referenceGuid: currProspect.guid,
					referenceType: "client",
					status: 3,
					type: "attachment",
				});
				
				followUpManager.save(newFollowUp)
				.then(() => {
					currProspect.addFollowUp(newFollowUp);
					Shark.render();
				});
			}
		}
	}
	
	cancelEditsBtn_clickHandler () {
		const currProspect = Shark.get("currProspect");

		if (!currProspect.isDirty() || (currProspect.isDirty() && confirm("Sei sicuro di voler annullare le modifiche apportate?"))) {
			currProspect.restore();

			if (Shark.get("isNewProspect")) {
				Shark.openPage(leadListView);
				Shark.set({
					isNewProspect: false,
					isEditingProspect: false
				});
			}
			else {
				Shark.set("isEditingProspect", false);
				this.render();
			}
		}
	}

	editItemBtn_clickHandler () {
		Shark.set("isEditingProspect", true);
	}

	async getAttachments () {
		const { currProspect } = Shark.get();

		const attachmentResponse = await documentManager.getByGuidList2(currProspect.leadAttachmentGuidList);
		console.log({attachmentResponse});

		if (currProspect.matchAttachments(attachmentResponse.data, true)) {
			Shark.render();
		}
	}
	
	init () {
		this.addComponents([followUpComponent, mainNavComponent]);
		
		Shark.__templateMap.followup_list_and_form = followup_list_and_form;

		Shark.set({
			agentList: Shark.get("agentList") || [],
			contactSourceListForMarketing: Shark.get("contactSourceList").filter(item => item.tags.indexOf("marketing-lead") > -1).sort((a, b) => a.label > b.label ? 1 : -1),
			isEditingProspect: Shark.get("isEditingProspect") || false
		});
	}

	prospectSourceField_changeHandler () {
		const prospectSourceField = document.querySelector("#prospectSourceField");
		const prospectFairSourceBox = document.querySelector("#prospectFairSourceBox");

		if (prospectSourceField) {
			if (parseInt(prospectSourceField.value) === 2) {
				prospectFairSourceBox.classList.add("d-block");
				prospectFairSourceBox.classList.remove("d-none");
			}
			else {
				prospectFairSourceBox.classList.remove("d-block");
				prospectFairSourceBox.classList.add("d-none");
			}
		}
	}

	saveChangesBtn_clickHandler () {
		console.log(Shark.get("currProspect"));
		const currProspect = Shark.get("currProspect");

		if (!currProspect.isValid("lead")) {
			Shark.render();
			alert("Attenzione, si sono verificati i seguenti errori:\n\n" + currProspect.__lastValidationErrors.join("\n").replace(/<br>/g, "\n"));
		}
		else {
			//Dave.ToDo: Spostiamo anche il salvataggio nel componente
			if (currProspect.__prospectAssignedAgentGuid !== "" && currProspect.__agentAssignmentDateLabel === "") {
				//Dave: bisognerebbe fare un FU che dica che è stato assegnato all'agente
				currProspect.set("__agentAssignmentDate", moment().format(Shark.get("dtIsoDate")));
			}
			const prospectToImportList = [currProspect];
			
			clientManager.saveProspectList(prospectToImportList)
			.then(() => {
				if (currProspect.extraData.leadIncomingMessage.trim() !== "" && currProspect.__followUpList.length === 0) {
					const newFollowUp = Shark.getInstance("ClientFollowUp", {
						body: currProspect.extraData.leadIncomingMessage.trim(),
						clientGuid: currProspect.guid,
						referenceGuid: currProspect.guid,
						referenceType: "client",
						status: 3,
						type: "leadIncomingMessage"
					});
					
					followUpManager.save(newFollowUp)
					.then(followUpSaveResponse => {
						currProspect.addFollowUp(newFollowUp);
						console.log({followUpSaveResponse});
					});
				}

				const currFollowUp = Shark.get("currFollowUp");

				if (currFollowUp) {
					if (currFollowUp.isDirty()) {
						currFollowUp.clientGuid = currProspect.guid;
						currFollowUp.referenceGuid = currProspect.guid;
						currFollowUp.referenceType = "client";
						currProspect.addFollowUp(currFollowUp);
						followUpManager.save(currFollowUp);
					}
				}

				if (!this.get("currProspectIsPremium") && currProspect.extraData.leadIsPremium) {
					console.log("Il lead è diventato Premium");
					communicationManager.leadPremiumInserted(currProspect);
				}

				Shark.set({
					isEditingProspect: false,
				});
				Shark.openPage(leadListView);
			})
			.catch(error => {
				console.error(error);
			});
		}
	}


	async uploadedAttachment_changeHandler (event) {
		// siteInfoSheetManager.uploadPicture(event.target);
		const uploadResult = await documentManager.upload(event.target);

		if (uploadResult.data?.documents.length > 0) {
			const documentList = uploadResult.data.documents;
			const documentSaveResponse = await documentManager.save2(documentList);
			console.log({documentSaveResponse, documentList});
			const { currProspect } = Shark.get();

			if (currProspect.addAttachments(documentList)) {
				let body = "";

				if (documentList.length === 1) {
					body = `È stato aggiunto l'allegato "<span role="attachment-name">${documentList[0].name}</span>".`;
				}
				else {
					const attachmentNames = documentList.map(item => {
						return `, "<span role="attachment-name">${item.name}</span>"`;
					}).join("");
					
					body = `Sono stati aggiunti i seguenti allegati:${attachmentNames.slice(1)}.`;
				}

				const newFollowUp = new ClientFollowUp({
					body,
					clientGuid: currProspect.guid,
					referenceGuid: currProspect.guid,
					referenceType: "client",
					status: 3,
					type: "attachment",
				});
				
				followUpManager.save(newFollowUp)
				.then(() => {
					currProspect.addFollowUp(newFollowUp);
					Shark.render();
				});
			}
		}
	}

	uploadAttachmentBtn_clickHandler () {
		document.querySelector("#uploadedAttachment").click();
	}

}

const leadDetailsView = new LeadDetailsView("leadDetailsView");

Shark.registerView(leadDetailsView);

export default leadDetailsView;
